/**
 * Class Name Utility
 * @layer atom
 * @package @plerity/ui-core
 */

import { type ClassValue, clsx } from "clsx";

/**
 * Joins class names with plain `clsx`. It does NOT de-duplicate conflicting Tailwind
 * utilities (`tailwind-merge` is not in the workspace lock, so it is not used here).
 *
 * Caveat for consumers passing `className` to override a component colour: when both
 * the component default and the override set the same property, the winner is decided
 * by the order Tailwind emits them in the compiled stylesheet, not by class-string order.
 * Variant-prefixed utilities (`dark:bg-gray-600`) are emitted AFTER plain ones
 * (`bg-surface`), so a plain override of a colour the component also sets under
 * `dark:` loses in dark mode. Override with the same variant (`dark:bg-...`) or, better,
 * add a component variant instead of overriding from the app.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
